import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
// Models
import mDoor from 'models/door';
// Custom
import { triggerInstallationScenario, deleteInstallationDoor } from 'actions';
import { doorsShape } from 'constants/PropTypesShapes';
import { doorMenuItems } from 'utils/MenuItems';
import { configurationDoorsAddPath, configurationDoorsShowPath } from 'installations/navigation';
import withPermissions from 'hocs/WithPermissions';
import withConfirmDialog from 'hocs/WithConfirmDialog';
import CollapseBoxTemplate from 'components/templates/CollapseBoxTemplate';
import LoadingDisplayer from 'components/misc/LoadingDisplayer';
import { AddTextButton } from 'components/buttons/TextButtons';
import withEntitiesInformation from 'installations/assets/hocs/WithEntitiesInformation';
import DoorItem from 'installations/assets/configuration/DoorItem';

class Doors extends React.Component {
  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
    this.handleTrigger = this.handleTrigger.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { deleted, onUpdate } = this.props;
    const { deleted: prevDeleted } = prevProps;
    if (!prevDeleted && deleted) {
      onUpdate();
    }
  }

  // Handlers
  handleDelete(door) {
    const { id, handleDisplayConfirm, handleDeleteDoor } = this.props;
    handleDisplayConfirm(
      { id: 'confirm.deleteDoor', values: { doorName: door.name } },
      () => handleDeleteDoor(id, door.id),
    );
  }

  handleTrigger(door) {
    const { id, handleTriggerScenario } = this.props;
    if (door.scenario) {
      handleTriggerScenario(id, door.scenario.id, door.scenario.name);
    }
  }

  render() {
    const {
      id, doors, hasPermission,
    } = this.props;
    const sortedDoors = mDoor.sortElements(doors.elements);

    // Permissions
    const { pInstallation: { configWrite, scenarioTrigger } } = permissions;

    return (
      <CollapseBoxTemplate
        title={<LocalizedMessage id="title.doors" />}
        buttons={[
          <OnlyWith
            key="bAdd"
            permissions={{
              needed: configWrite,
              permissionsOrContext: 'installationPermissions',
            }}
          >
            <AddTextButton primary path={configurationDoorsAddPath(id)} />
          </OnlyWith>,
        ]}
      >
        <div className="p-3">
          <LoadingDisplayer loading={doors.loading}>
            <div className="row information-item-wrapper">
              {_isEmpty(sortedDoors) && (
                <div className="col-12 mt-3">
                  <em>
                    <LocalizedMessage id="info.listNoElement" />
                  </em>
                </div>
              )}
              {!!sortedDoors
                && _map(sortedDoors, (door) => (
                  <div key={_toString(door.id)} className="col-lg-6 col-md-12">
                    <DoorItem
                      door={door}
                      menuItems={doorMenuItems(
                        { path: configurationDoorsShowPath(id, door.id), visible: hasPermission({ needed: configWrite, permissionsOrContext: 'installationPermissions' }) },
                        { cb: this.handleDelete, visible: hasPermission({ needed: configWrite, permissionsOrContext: 'installationPermissions' }) },
                        { cb: this.handleTrigger, visible: !!door.scenario && hasPermission({ needed: scenarioTrigger, permissionsOrContext: 'installationPermissions' }) },
                      )}
                      permissions={{
                        needed: `${configWrite}||${scenarioTrigger}`,
                        permissionsOrContext: 'installationPermissions',
                      }}
                    />
                  </div>
                ))}
            </div>
          </LoadingDisplayer>
        </div>
      </CollapseBoxTemplate>
    );
  }
}

Doors.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  deleted: PropTypes.bool.isRequired,
  doors: doorsShape.isRequired,
  onUpdate: PropTypes.func.isRequired,
  hasPermission: PropTypes.func.isRequired,
  handleDisplayConfirm: PropTypes.func.isRequired,
  handleTriggerScenario: PropTypes.func.isRequired,
  handleDeleteDoor: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  doors: state.installationDoor.list,
  deleted: state.installationDoor.delete.deleted,
});

const mapDispatchToProps = (dispatch) => ({
  handleTriggerScenario: (id, idScenario, name) => {
    dispatch(triggerInstallationScenario(id, idScenario, name));
  },
  handleDeleteDoor: (id, idDoor) => {
    dispatch(deleteInstallationDoor(id, idDoor));
  },
});

module.exports = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withPermissions,
  withConfirmDialog,
  withEntitiesInformation,
)(Doors);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/configuration/routes/index/components/InstallationConfigurationDoors.js